import { isGdprCountry } from './GdprExcludedCountries';
import { doIpLookup } from './ipLookup';
let eventDetails = {
  consent: null,
  country: null,
  isGdprCountry: false
};
/**
 * Only meant to be used during tests to clear side-effects
 */

export function cleanupDuringTest() {
  window._hsp = [];
  eventDetails = {
    consent: null,
    country: null,
    isGdprCountry: false
  };
}
export const GdprEventSetup = (lookup = doIpLookup) => {
  window._hsp = window._hsp || [];
  const lookupPromise = lookup().then(country => {
    eventDetails.country = country;
    eventDetails.isGdprCountry = isGdprCountry(country);
    document.dispatchEvent(new CustomEvent('gdpr', {
      detail: eventDetails
    }));
  });

  window._hsp.push(['addPrivacyConsentListener', consent => {
    eventDetails.consent = consent;
    document.dispatchEvent(new CustomEvent('gdpr', {
      detail: eventDetails
    }));
  }]);

  return lookupPromise;
};